import { useEffect, useRef } from 'react';
import { useContentStateStore } from '@jwp/ott-common/src/stores/ContentStateStore';

export function useScrollRestoration(pageId: string) {
  const pageState = useContentStateStore((s) => s.pages[pageId]);
  const setPageState = useContentStateStore((s) => s.setPageState);
  const restoredRef = useRef(false);

  useEffect(() => {
    if (!pageState?.scrollPosition || restoredRef.current) { return; }

    const targetPos = pageState.scrollPosition;

    const tryRestore = () => {
      if (document.documentElement.scrollHeight > targetPos) {
        window.scrollTo({ top: targetPos });
        restoredRef.current = true; // done
      } else {
        // keep retrying until DOM is tall enough
        setTimeout(tryRestore, 100);
      }
    };

    tryRestore();
  }, [pageState?.scrollPosition, pageId]);

  useEffect(() => {
    const handleScroll = () => {
      setPageState(pageId, { scrollPosition: window.scrollY, from: pageId });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pageId, setPageState]);
}
